import React from 'react';
import { Link } from 'react-router-dom';
import { useOwlCarouselInit } from '../../hooks/useOwlCarouselInit';

export default function CaseStudies() {
    useOwlCarouselInit();
    return (
        <section className="case-studies-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                        <div className="section-title-s3">
                            <div className="icon">
                                <i className="fi flaticon-suitcase"></i>
                            </div>
                            <span>Here Our Best Work</span>
                            <h2>Recent Case Studies</h2>
                            <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero sit amet adipiscing</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content-area">
                <div className="case-studies-grids case-studies-slider owl-carousel owl-theme">
                    <div className="grid">
                        <div className="img-holder">
                            <img src="assets/images/case-studies/img-1.jpg" alt="" />
                        </div>
                        <div className="overlay">
                            <div className="content">
                                <p className="cat">Law service</p>
                                <h3><Link to="/project-single">Personal Injury</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="img-holder">
                            <img src="assets/images/case-studies/img-2.jpg" alt="" />
                        </div>
                        <div className="overlay">
                            <div className="content">
                                <p className="cat">Law service</p>
                                <h3><Link to="/project-single">Personal Injury</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="img-holder">
                            <img src="assets/images/case-studies/img-3.jpg" alt="" />
                        </div>
                        <div className="overlay">
                            <div className="content">
                                <p className="cat">Law service</p>
                                <h3><Link to="/project-single">Personal Injury</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="img-holder">
                            <img src="assets/images/case-studies/img-4.jpg" alt="" />
                        </div>
                        <div className="overlay">
                            <div className="content">
                                <p className="cat">Law service</p>
                                <h3><Link to="/project-single">Personal Injury</Link></h3>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="img-holder">
                            <img src="assets/images/case-studies/img-5.jpg" alt="" />
                        </div>
                        <div className="overlay">
                            <div className="content">
                                <p className="cat">Law service</p>
                                <h3><Link to="/project-single">Personal Injury</Link></h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}